import $form from 'axios';
import qs from 'qs';
import baseURL from './base_url.js';
import { Message } from 'element-ui';
import country from '../local/country';
import getLang from '../i18n/getLang'
const lang = getLang()

$form.defaults.timeout = 900000 // 响应时间
$form.defaults.responseType = 'json'
$form.defaults.baseURL = `${baseURL}` // 配置接口地址
$form.defaults.headers['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8' // 配置请求头

$form.defaults.transformRequest = [
  function (params) {
    return qs.stringify(params)
  }
]

let $jsonp = $form.create({
  baseURL: `${baseURL}`, // 配置接口地址
  headers: {
    ['Content-Type']: 'application/json;charset=UTF-8'
  },
  transformRequest: [
    function (params) {
      return JSON.stringify(params)
    }
  ]
})



// json 提交方式
let $json = $form.create({
  baseURL: `${baseURL}`, // 配置接口地址
  headers: {
    ['Content-Type']: 'application/json;charset=UTF-8'
  },
  transformRequest: [
    function (params) {
      return JSON.stringify(params)
    }
  ]
})
function interceptorsJSONPRequestSuccess(config) {
  return config
}
function interceptorsJSONPResponseSuccess(response) {

  return response.data
}

function interceptorsRequestSuccess(config) {
  config.headers['myversion'] = '1.1.0'
  config.headers['version'] = '1.1.01'
  config.headers['Language'] = localStorage.getItem('localLang') || 'cn'
  const cid = localStorage.getItem('COUNTRY') || 'NL';
  config.headers['client-postcode-id'] = localStorage.getItem('CID') ? localStorage.getItem('CID') : ''
  config.headers['cid'] = localStorage.getItem('COUNTRYID') || ''
  config.headers['X-Requested-With'] = 'XMLHttpRequest' // 测试字段
  if (process.env.NODE_ENV === 'development') {
    config.headers['vvvvv'] = 'test'
  }
  if (/\/cn/.test(config.baseURL) && /apply_shop/.test(config.url)) {
    config.baseURL = config.baseURL.replace(/\/cn/, '')
  }
  return config
}
const defaultMsg = 'Server error, please contact customer service.'
// 不包括的请求
const excludeReg = /(user-info|car|quantity|favorite|user_visit)/
function interceptorsResponseSuccess(response) {
  if (!response.data.ret && !response.data.status) {
    const msg = response.data.msg || response.data.tips || response.data.message || defaultMsg
    !response.config.no_message && Message({ message: msg, type: 'error' })
    response.data.statusCode = response.status
    return Promise.reject(response.data)
  }
  return response.data
}
function interceptorsResponseError(error) {
  if (!error.request) return error
  const request = error.request
  const homeUrl = location.origin + (lang === 'en' ? '' : (lang === 'nl' ? '/nl' : `/cn`))
  // 401
  if (request.status === 401 && request.responseURL.indexOf('/account') == -1) {
    const route = window.location;
    const localLang = localStorage.getItem("localLang");
    let url = `${route.origin}${localLang != "en" ? "/" + localLang : ""
      }/login`;
    route.href = url;
    return
  }
  // if (request.status === 401 && !excludeReg.test(request.responseURL) && location.href != homeUrl && location.href != homeUrl+'/' && !/uuid/.test(location.search)) {
  //   // 未登录并且不是用户协议界面,跳转到首页
  //   if (location.pathname.indexOf('agreement') === -1) {
  //     location.href = baseURL;
  //   }
  // }
  if (error.request.status !== 401) {
    const msg = error.response.data.msg || error.response.data.tips || error.response.data.message || defaultMsg
    !error.config.no_message && Message({ message: msg, type: 'error' })
  }
  error.response.data.statusCode = request.status
  return Promise.reject(error.response.data)
}
// json请求拦截器
$json.interceptors.request.use(interceptorsRequestSuccess);
// json 响应拦截器
$json.interceptors.response.use(interceptorsResponseSuccess, interceptorsResponseError);
// form请求拦截器
$form.interceptors.request.use(interceptorsRequestSuccess);
// from 响应拦截器
$form.interceptors.response.use(interceptorsResponseSuccess, interceptorsResponseError);
$jsonp.interceptors.request.use(interceptorsJSONPRequestSuccess);
$jsonp.interceptors.response.use(interceptorsJSONPResponseSuccess, interceptorsResponseError);
export { $json, $form, $jsonp }
export default function (Vue) {
  Vue.prototype.$form = $form;
  Vue.prototype.$json = $json;
  Vue.prototype.$jsonp = $jsonp;
}


// WEBPACK FOOTER //
// ./resources/js/lib/axios/index.js